/* eslint-disable */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import TableList from "components/TableList";
import * as UserActionType from "../constants";
import { Link, RouteComponentProps } from "react-router-dom";
import { SimpleDataTable } from "../../components/data-table/simple-data-table";
import { PaginationDataTable } from "../../components/data-table/pagination-data-table";
import { ContextMenu } from "../../components/context-menu/context-menu";
import { MessengerBox } from "../../components/messenger-box/messenger-box";
import { CheckBox } from "components/checkboxes/check-box";
import { Popup } from "../../components/Popup/popup";
import { AppSettings } from "../../constants";
import * as UnitHelper from "../../helper/unit-helper";
import ConfirmModal from "components/ConfirmModal";
import componentActions from "../../components/actions";
import usersAction from "../actions";
import EditUserModal from "./EditUserModal";
import UnassignUserFromProjectModal from "../Components/unassign-user-from-project";
import SuspendUserModal from "../Components/suspend-user";

const defaultParams = {
  defaultSortName: "fullName",
  defaultSortOrder: "ascending",
  sizePerPage: 10
};

let defaultCheckedValues = [];
AppSettings.USER_STATUS_VALUE.map(item => {
  defaultCheckedValues.push(item.key);
});

const TABLE_NAME = "USER_LIST";

class ManageUsers extends Component {
  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.UserStore.ManageUser.params.take
    );

    this.state = {
      defaultSortName: props.UserStore.ManageUser.params.sort.field, // default sort column name
      defaultSortOrder: props.UserStore.ManageUser.params.sort.order, // default sort order,
      currentPage: props.UserStore.ManageUser.params.skip,
      sizePerPage: this.sizePerPage,
      totalRecord: props.UserStore.ManageUser.params.totalRecord,
      data: props.UserStore.ManageUser.items,
      status: props.UserStore.ManageUser.params.status,

      columns: [
        {
          title: "Name",
          name: "fullName",
          sort: true,
          defaultSortOrder: "ascending"
        },
        { title: "Email", name: "email", sort: true },
        {
          title: "Role",
          name: "roleName",
          sort: true,
          customRender: this.customRenderRole.bind(this)
        },
        {
          title: "Status",
          name: "statusValue",
          customRender: this.customRenderStatus.bind(this)
        },
        {
          title: "",
          name: "",
          customRender: this.customRenderBtnAction.bind(this),
          className: "cls-colm-action"
          //icon: "glyphicon glyphicon-option-vertical cls-table-black-icon",
          //event: this.onContextMenu.bind(this),
        }
      ],

      isShowPopup: false,
      checkedValues: [],
      isOpenSuspendUserModal: false,
      errorSuspend: false
    };
  }

  componentWillMount() {
    this.setState({
      checkedValues: defaultCheckedValues
    });
    if (AppSettings.clientTypeValue === "Subcontractor") {
      this.props.history.push("/subcontractor/work-order");
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      UserStore: { ManageUser }
    } = nextProps;
    if (ManageUser) {
      this.setState({
        totalRecord: ManageUser.params.totalRecord,
        data: ManageUser.items,
        status: ManageUser.params.status,
        currentPage: ManageUser.params.skip
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  customRenderRole(item) {
    const roleName = AppSettings.LIST_ROLES.filter(t => {
      return t.key === item.roleName;
    })[0].value;
    return <span>{roleName}</span>;
  }

  toolTip(item) {
    return (
      <Tooltip id={item.id} className="in tooltip-siteone">
        <span>{item.lockErrorMsg}</span>
      </Tooltip>
    );
  }

  customRenderStatus(item) {
    switch (item.status) {
      case AppSettings.USER_STATUS.PENDING:
        return (
          <div className="pill-indicators warning">{item.statusValue}</div>
        );
      case AppSettings.USER_STATUS.ACTIVE:
        return (
          <div className="pill-indicators success">{item.statusValue}</div>
        );
      case AppSettings.USER_STATUS.SUSPENDED:
        return <div className="pill-indicators danger">{item.statusValue}</div>;
      case AppSettings.USER_STATUS.LOCKED:
        return (
          <OverlayTrigger
            placement="top"
            overlay={this.toolTip(item)}
            delayHide={10}
            delayShow={500}
          >
            <div className="pill-indicators locked">{item.statusValue}</div>
          </OverlayTrigger>
        );
        break;
      default:
        return;
    }
  }

  customRenderBtnAction(item) {
    if (item.userId === localStorage[AppSettings.S1_UID]) {
      return (
        <a
          className="glyphicon glyphicon-option-vertical cls-table-black-icon"
          style={{ opacity: "0.5", cursor: "no-drop" }}
        />
      );
    } else {
      return (
        <a
          className="glyphicon glyphicon-option-vertical cls-table-black-icon"
          onClick={e => {
            this.onContextMenu(e, item);
          }}
        />
      );
    }
  }

  onCheckRoleGreaterEqual = item => {
    const { roleName } = item;

    const currentUserRole = this.props.UserStore.UserProfile.roleName;

    const listRole = AppSettings.LIST_ROLES;

    const itemRoleIndex = listRole.findIndex(x => x.key === roleName);

    const currentUserRoleIndex = listRole.findIndex(
      x => x.key === currentUserRole
    );

    return currentUserRoleIndex <= itemRoleIndex;
  };

  onContextMenu(e, item) {
    const currentUserRoleGreaterEqualToItemRole =
      this.onCheckRoleGreaterEqual(item) &&
      AppSettings.clientTypeValue === "Builder";

    var contextItem = [];
    switch (item.status) {
      case AppSettings.USER_STATUS.PENDING:
        contextItem = [
          {
            title: "Resend activation email",
            icon: "glyphicon glyphicon-envelope",
            event: this.onResendActiveEmail.bind(this)
          },
          {
            title: "Edit user information",
            icon: "glyphicon glyphicon-pencil",
            event: this.onOpenEditUser.bind(this)
          },
          {
            title: "Delete",
            icon: "glyphicon glyphicon-remove",
            event: this.onDelete.bind(this)
          }
        ];
        break;
      case AppSettings.USER_STATUS.ACTIVE:
        if (AppSettings.clientTypeValue === "Builder") {
          contextItem = [
            {
              title: "Reset password",
              icon: "glyphicon glyphicon-repeat",
              event: this.onResetPassword.bind(this)
            },
            {
              title: "Edit user information",
              icon: "glyphicon glyphicon-pencil",
              event: this.onOpenEditUser.bind(this)
            },
            {
              title: "Unassign from project",
              icon: "glyphicon glyphicon-pencil",
              event: this.toggleUnassignUserFromProjectModal.bind(this)
            }
          ];
        } else {
          contextItem = [
            {
              title: "Reset password",
              icon: "glyphicon glyphicon-repeat",
              event: this.onResetPassword.bind(this)
            },
            {
              title: "Edit user information",
              icon: "glyphicon glyphicon-pencil",
              event: this.onOpenEditUser.bind(this)
            }
          ];
        }

        if (currentUserRoleGreaterEqualToItemRole) {
          contextItem.push({
            title: "Suspend",
            icon: "glyphicon glyphicon-lock",
            event: this.onSuspend.bind(this)
          });
        }

        break;
      case AppSettings.USER_STATUS.SUSPENDED:
        contextItem = [
          {
            title: "Edit user information",
            icon: "glyphicon glyphicon-pencil",
            event: this.onOpenEditUser.bind(this)
          }
          // {
          //   title: 'Restore',
          //   icon: 'glyphicon glyphicon-refresh',
          //   event: this.onSuspend.bind(this)
          // }
        ];
        break;
      case AppSettings.USER_STATUS.LOCKED:
        contextItem = [
          {
            title: "Edit user information",
            icon: "glyphicon glyphicon-pencil",
            event: this.onOpenEditUser.bind(this)
          }
        ];

        if (currentUserRoleGreaterEqualToItemRole) {
          contextItem.push({
            title: "Suspend",
            icon: "glyphicon glyphicon-lock",
            event: this.onSuspend.bind(this)
          });
        }

        if (item.lockedType === AppSettings.LOCKED_TYPE.CHANGE_EMAIL) {
          contextItem.unshift({
            title: "Resend confirmation email",
            icon: "glyphicon glyphicon-envelope",
            event: this.onResendConfirmEmail.bind(this)
          });
          contextItem.unshift({
            title: `User has not confirmed new email address ${item.email}`,
            icon: "glyphicon glyphicon-info-sign",
            event: this.onDoNothing.bind(this),
            info: true
          });
          contextItem.unshift({
            title: "Reset password",
            icon: "glyphicon glyphicon-repeat",
            event: this.onResetPassword.bind(this)
          });
        } else {
          contextItem.unshift({
            title: "Reset password",
            icon: "glyphicon glyphicon-repeat",
            event: this.onResetPassword.bind(this)
          });
        }
        break;
      default:
        return;
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onOpenEditUser(e, item) {
    const errorMsg = this.props.UserStore.ErrorMsg;
    var params = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      email: this.search.value.trim()
    };

    this.props.toggleModal({
      modalName: EditUserModal.MODAL_NAME,
      modalProps: {
        cancelText: "Cancel",
        title: "Edit user information",
        okText: "Ok",
        item: item,
        errorMsg: errorMsg,
        search: params
      },
      ActiveModal: EditUserModal
    });
  }

  toggleUnassignUserFromProjectModal(e, userInfo) {
    this.setState({
      isOpenUnassignModal: !this.state.isOpenUnassignModal,
      userInfo
    });
  }

  onResendActiveEmail(e, item) {
    /* this.onSaveUser(e, {
      userId: item.userId,
      redirectUrl: AppSettings.REDIRECT_URL_INVITE
    }, UserActionType.RESEND_INVITE_ASYNC);
    */
    var params = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      email: this.search.value.trim()
    };
    this.props.usersAction.resendInviteAsync({
      params: {
        data: {
          userId: item.userId,
          redirectUrl: AppSettings.REDIRECT_URL_INVITE
        },
        search: params
      }
    });
  }

  onResetPassword(e, item) {
    const params = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      email: this.search.value.trim()
    };
    this.props.usersAction.resetPasswordAsync({
      params: {
        data: {
          userId: item.userId,
          clientId: AppSettings.CLIENT_ID,
          redirectUrl: AppSettings.REDIRECT_RESET_PASSWORD,
          toastMsg: "Request sent"
        },
        search: params
      }
    });
  }

  onResendConfirmEmail(e, item) {
    var params = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      email: this.search.value.trim()
    };
    this.props.usersAction.resendConfirmEmailAsync({
      params: {
        data: {
          userId: item.userId,
          redirectUrl: AppSettings.REDIRECT_URL_EMAIL_CONFIRM
        },
        search: params
      }
    });
  }

  onDoNothing() {}

  onDelete(e, item) {
    const params = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      email: this.search.value.trim()
    };

    this.props.toggleModal({
      modalName: ConfirmModal.MODAL_NAME,
      modalProps: {
        message: `Delete ${item.email} ?`,
        cancelText: "Cancel",
        cancelClass: "btn btn-primary btn-siteone-default",
        title: "Delete",
        okText: "Delete",
        okClass: "btn btn-siteone btn-siteone-danger",
        show: true,
        okFunc: () => {
          //this.selectFileToUpdate();
          this.props.usersAction.removeUserAsync({
            params: {
              data: {
                userId: item.userId
              },
              search: params
            }
          });

          this.props.toggleModal({ modalName: "", ActiveModal: null });
        }
      },
      ActiveModal: ConfirmModal
    });
  }

  onSuspend(e, item) {
    // window.alert('This method is not implementation yet');
    // this.onToggleSuspendUserModal();
    this.setState({
      isOpenSuspendUserModal: true,
      userSuspend: item
    });
  }

  onCloseSuspendModal = () => {
    this.setState({
      isOpenSuspendUserModal: false,
      errorSuspend: false
    });
  };

  onConfirmSuspendUser = () => {
    const paramsSearch = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      email: this.search.value.trim()
    };

    this.props.dispatch({
      type: UserActionType.SUSPEND_USER_ASYNC,
      params: {
        userid: this.state.userSuspend.userId,
        paramsSearch
      },
      callback: status => {
        if (status) {
          this.setState({
            userId: null,
            isOpenSuspendUserModal: false,
            errorSuspend: false
          });
        } else {
          this.setState({
            errorSuspend: true
          });
        }
      }
    });
  };

  onRestore(e, item) {}

  onSaveUser(e, data, userActionType) {
    var params = {
      ...this.objToParams(this.props.UserStore.ManageUser.params),
      searchKey: this.search.value.trim()
    };
    this.props.dispatch({
      type: userActionType,
      params: {
        data: data,
        search: params
      }
    });
  }

  onTableBinding(configTable) {
    var params = this.objToParams(this.props.UserStore.ManageUser.params);
    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  binding(params) {
    this.props.usersAction.searchUserAsync({
      params: params
    });
  }

  onTogglePopupFilter = e => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  };

  componentDidMount() {
    const self = this;
    this.binding(
      this.objToParams({
        ...this.props.UserStore.ManageUser.params,
        take: this.state.sizePerPage
      })
    );
    window.addEventListener("click", e => {
      if (
        document.getElementById("s1-popup") &&
        document.getElementById("s1-popup").contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById("popup-button") &&
          document.getElementById("popup-button").contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillUnmount() {
    this.props.usersAction.resetManageUser({});
  }

  onChecked = (e, data) => {
    var status = UnitHelper.isEmpty(data.toString()) ? "" : data.toString();

    if (status !== "") {
      var params = this.objToParams(this.props.UserStore.ManageUser.params);
      if (status.split(",").length === 4) {
        status = "all";
      }
      this.binding({
        ...params,
        status: status,
        skip: 0
      });
    } else {
      this.setState({ data: [] });
    }
  };

  onEnter(e) {
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  onSearch(e) {
    var params = this.objToParams(this.props.UserStore.ManageUser.params);

    this.setState({
      checkedValues: defaultCheckedValues
    });

    this.binding({
      ...params,
      status: "all",
      skip: 0
    });
  }

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter(item => item !== value)
          ]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  objToParams(obj) {
    return {
      searchKey: this.search.value.trim(),
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.usersAction.searchUserAsync({
          params: {
            searchKey: this.search.value.trim(),
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  render() {
    const data = this.state.data;

    const column = [
      {
        field: "userId",
        header: "id",
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: "left",
        headerAlign: "left"
      },
      {
        field: "fullName",
        header: "Name",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left"
      },
      {
        field: "email",
        header: "Email",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left"
      },
      {
        field: "roleName",
        header: "Role",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderRole.bind(this)
      },
      {
        field: "status",
        header: "Status",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderStatus.bind(this)
      },
      {
        field: "",
        header: "",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "right",
        headerAlign: "right",
        customRender: this.customRenderBtnAction.bind(this),
        className: "column-action",
        columnClassName: "column-action"
      }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord
    };

    const customHeader = (
      <div className="table-header">
        <Row>
          <Col sm={12} md={12} className="text-right">
            <div className="box-search">
              <div className="input-group">
                <input
                  type="text"
                  id="txt-search-email"
                  ref={ref => (this.search = ref)}
                  className="form-control"
                  placeholder="Search"
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className="input-group-btn">
                  <button
                    onClick={this.onSearch.bind(this)}
                    className="btn btn-secondary"
                  >
                    <span className="fa fa-search" aria-hidden="true" />
                  </button>
                </span>
              </div>
            </div>
            <div className="manage-user-filter pull-right">
              <button
                id="popup-button"
                onClick={this.onTogglePopupFilter}
                className="btn btn-secondary fa fa-filter btn-icon"
              />
              {this.state.isShowPopup && (
                <Popup
                  ref={ref => {
                    this.popup = ref;
                  }}
                >
                  {AppSettings.USER_STATUS_VALUE.map(item => {
                    let className;
                    switch (item.key) {
                      case AppSettings.USER_STATUS.ACTIVE:
                        className = "checkbox-success";
                        break;
                      case AppSettings.USER_STATUS.PENDING:
                        className = "checkbox-warning";
                        break;
                      case AppSettings.USER_STATUS.SUSPENDED:
                        className = "checkbox-danger";
                        break;
                      default:
                        className = "checkbox-locked";
                        break;
                    }
                    return (
                      <CheckBox
                        checked={this.state.checkedValues.includes(item.key)}
                        name="status"
                        className={className}
                        value={item.key}
                        key={item.key}
                        label={item.value}
                        handleChange={this.handleChange}
                      />
                    );
                  })}
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id="manage-user">
        <div className="page-title clearfix">
          <h2 className="pull-left">Users ({this.state.totalRecord})</h2>
          <Link
            className="btn btn-primary btn-info btn-siteone pull-right btn-icon"
            to={"/users/inviteuser"}
          >
            <span className="fa fa-plus icon" />
            NEW
          </Link>
        </div>
        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <TableList
          ref={ref => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
        />
        {this.state.isOpenUnassignModal && (
          <UnassignUserFromProjectModal
            dispatch={this.props.dispatch}
            closeModal={this.toggleUnassignUserFromProjectModal.bind(this)}
            isOpen={this.state.isOpenUnassignModal}
            userInfo={this.state.userInfo}
          />
        )}

        {this.state.isOpenSuspendUserModal && (
          <SuspendUserModal
            isOpen={this.state.isOpenSuspendUserModal}
            username={this.state.userSuspend.fullName}
            error={this.state.errorSuspend}
            onClose={this.onCloseSuspendModal}
            onSuspend={this.onConfirmSuspendUser}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    UserStore: state.UserStore,
    PageSizeReference: state.BuilderStore.PageSizeReference
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: bindActionCreators(componentActions.toggleModal, dispatch),
    usersAction: bindActionCreators(usersAction, dispatch),
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageUsers);



// WEBPACK FOOTER //
// ./src/User/Containers/manage-users.js